module.exports = __webpack_public_path__ + "static/img/rooftop page top img_mobile.2846faa3.jpg";